import React from 'react';
import Layout from '../../components/Layout';
import PostAProject from './PostAProject';

const title = 'Post a Project — BestHand';
const description =
  'Tell us about your home-improvement project and get matched with vetted BestHand pros. Pick a service, answer a few quick questions, add your budget and timeline, and submit — free to post.';

async function action({ largeProjectsEnabled }) {
  // LARGE PROJECTS FLAG: when OFF this LP route is unreachable -> redirect home
  // (additive guard; small-jobs routes untouched). Flag read from the router
  // context (server-only DB read in server.js / SSR-seeded runtime on client);
  // fail-closed at the source.
  if (!largeProjectsEnabled) {
    return { redirect: '/' };
  }
  return {
    title,
    description,
    component: (
      <Layout>
        <PostAProject />
      </Layout>
    ),
  };
}

export default action;
